import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingCode\UpdateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/UpdateAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
const UpdateAccountingCodeController = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAccountingCodeController.url(args, options),
    method: 'put',
})

UpdateAccountingCodeController.definition = {
    methods: ["put"],
    url: '/api/accounting-code/{accounting_code}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\AccountingCode\UpdateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/UpdateAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
UpdateAccountingCodeController.url = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_code: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_code: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_code: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_code: typeof args.accounting_code === 'object'
        ? args.accounting_code.id
        : args.accounting_code,
    }

    return UpdateAccountingCodeController.definition.url
            .replace('{accounting_code}', parsedArgs.accounting_code.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingCode\UpdateAccountingCodeController::__invoke
* @see app/Http/Controllers/AccountingCode/UpdateAccountingCodeController.php
* @route '/api/accounting-code/{accounting_code}'
*/
UpdateAccountingCodeController.put = (args: { accounting_code: string | number | { id: string | number } } | [accounting_code: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAccountingCodeController.url(args, options),
    method: 'put',
})

export default UpdateAccountingCodeController